import {useEffect, useState} from 'react';
import {useAppSelector} from "../../../../app/hooks";
import { useDispatch } from "react-redux";
import { ProductsModel, ProductsVariantsModel } from "../../../../data/Products";
import {addProduct} from "../../../../features/project-slice";
import {setProductActive, setProductDraggable} from "../../../../features/visual-area-slice";
import {gridPoint} from "../../../../utils/global";
import useTranslate from "../../../../utils/useTranslate"
import Infos, {InfosProps} from "../Infos/Infos"

import { ProjectBathingLadderModel } from "../../../../data/products/BathingLadder";
import ProductBathingLadder from "../../../shared/Products/BathingLadder/ProductBathingLadder";

import { ProjectBoardingAidModel } from "../../../../data/products/BoardingAid";
import ProductBoardingAid from "../../../shared/Products/BoardingAid/ProductBoardingAid";

import './MenuItemAccessories.scss';

export const MenuItemAccessories = () => {
    const {t} = useTranslate();
    const dispatch = useDispatch();
    const {visualArea, project} = useAppSelector((state) => state);
    const [addedProduct, setAddedProduct] = useState<number | null>(null);
    const [showInfoForProduct, setShowInfoForProduct] = useState<InfosProps | null>(null);

    useEffect(() => {
        if (addedProduct === null) {
            return;
        }
        dispatch(setProductActive(addedProduct));
        dispatch(setProductDraggable(addedProduct));
        setAddedProduct(null);
    }, [dispatch, addedProduct]);

    const addBathingLadder = (iBathingLadder: ProductsModel, isBathingLadder: ProductsVariantsModel) => {
        if (visualArea.groupPosition === null || visualArea.scale === null) {
            return;
        }
        let x = ((visualArea.paintDimensions.width / 2) - visualArea.groupPosition.x) / visualArea.scale;
        let y = ((visualArea.paintDimensions.height / 2) - visualArea.groupPosition.y) / visualArea.scale;
        let newProduct: ProjectBathingLadderModel = {
            group: iBathingLadder.group,
            typ: iBathingLadder.typ,
            variant: isBathingLadder.typ,
            x: x,
            y: y,
            rotate: 0
        };
        gridPoint(newProduct, iBathingLadder.grid);

        dispatch(addProduct(newProduct));
        setAddedProduct(project.products.length);
    };

    const addBoardingAid = (iBoardingAid: ProductsModel, isBoardingAid: ProductsVariantsModel) => {
        if (visualArea.groupPosition === null || visualArea.scale === null) {
            return;
        }
        let x = ((visualArea.paintDimensions.width / 2) - visualArea.groupPosition.x) / visualArea.scale;
        let y = ((visualArea.paintDimensions.height / 2) - visualArea.groupPosition.y) / visualArea.scale;
        let newProduct: ProjectBoardingAidModel = {
            group: iBoardingAid.group,
            typ: iBoardingAid.typ,
            variant: isBoardingAid.typ,
            x: x,
            y: y,
            rotate: 0
        };
        gridPoint(newProduct, iBoardingAid.grid);

        dispatch(addProduct(newProduct));
        setAddedProduct(project.products.length);
    };

    const setInfoForProduct = (pmodel: ProductsModel) => {
        let nt: InfosProps = {
            title: pmodel.title,
            info: pmodel.info
        };
        if (JSON.stringify(nt) !== JSON.stringify(showInfoForProduct)) {
            setShowInfoForProduct(nt);
        }
    };

    return (
        <div className="ams-menu-item-accessories">
            <div className="ams-menu-item-accessories-title">
                {t('Zubehör')}
            </div>
            {
                showInfoForProduct === null &&
                <>
                    <div className="ams-menu-item-accessories-items">
                        <ProductBathingLadder selectProductVariant={addBathingLadder} infoForProduct={setInfoForProduct}  />
                    </div>
                    <div className="ams-menu-item-accessories-items">
                        <ProductBoardingAid selectProductVariant={addBoardingAid} infoForProduct={setInfoForProduct}  />
                    </div>
                </>
            }
            {
                showInfoForProduct !== null &&
                <Infos title={showInfoForProduct.title} info={showInfoForProduct.info} onClose={() => {setShowInfoForProduct(null);}} />
            }
        </div>
    );
};

export default MenuItemAccessories;
